import React, { useContext } from "react";
import { Button, message, Modal, Upload, Spin } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { useGoodsModel } from "../goodsModel";
import { DataTable } from "./DataTable";
import { MyContext } from "@/store/myContext";
import { importPropsConfig } from "@/erp_subpackage/utils/importFile";
import moment from 'moment';
import { getUserBtn } from "@/utils/dataStorage"

export const DataBox = () => {
    const { selectedRowKeys, shopId, shopName, searchParam, exportGoods, sync, downloadTpl, loadData, uploading, setUploading } = useGoodsModel();
    const { state, dispatch, detailsPage } = useContext(MyContext);
    //新增 查看 编辑
    const goPageNav = (mode) => {
        let tabName = {
            add: "商品新增",
            edit: "商品编辑",
            look: "商品查看",
        }
        let modeKey = "baseGoods/" + mode;

        //动态传入要删除的nav key
        const handleDispatch = (obj = {}) => {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.BaseGoodsDetails({
                    modeKey,
                    mode,
                    dispatch,
                    rowId: selectedRowKeys[0]
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find(item => item.key === modeKey);
            if (findNav) {
                Modal.confirm({
                    title: '温馨提醒！',
                    content: "您还有商品详情未保存，是否跳转",
                    okText: '跳转未保存页',
                    cancelText: '打开新页签',
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    }
                });
                return;
            }
            handleDispatch()
        }
        else if (mode === "add") {
            handleDispatch()
        }
    }

    const uploadCallback = (params) => {
        setUploading({ spinning: false })
        params && loadData()
    }

    //资源权限
    const butResourceApply = (str) => {
        let resource = getUserBtn("baseGoods") || {}
        resource = resource.children || []
        return resource.find((item) => item.path === str) ? true : false
    }
    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                goPageNav("add")
            }}
        >新增</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！")
                    return;
                }
                goPageNav("edit")
            }}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >编辑</Button>
        <Upload showUploadList={false} {...importPropsConfig(`/ci-storage/base/material/import`, uploadCallback, { shopId, shopName }, () => setUploading({ spinning: true, tip: "加速上传中..." }))} >
            <Button
                className="btn-item"
                shape="round"
                disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
            >导入</Button>
        </Upload>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => exportGoods()}
        >导出</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => downloadTpl()}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >下载模板</Button>
        <Upload showUploadList={false} {...importPropsConfig(`/ci-storage/base/material/importImg`, uploadCallback, { shopId, shopName }, () => setUploading({ spinning: true, tip: "加速上传中..." }), "zip")}>
            <Button className="btn-item" shape="round" disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}>导入图片</Button>
        </Upload>
        {/* {butResourceApply("shopArchivesSynchronization") && (
            <Button
                className="btn-item"
                shape="round"
                onClick={() => sync()}
            >
                同步
            </Button>
        )} */}
        {/* {butResourceApply("shopArchivesAddSynchronization") && (
            <Button
                className="btn-item"
                shape="round"
                onClick={() => sync({ createTime: moment(new Date()).format("YYYY-MM-DD") })}
            >
                增量同步
            </Button>
        )} */}
        {/* <Upload showUploadList={false} {...importPropsConfig(`/ci-storage/base/material/importMaterialPrice/${shopId}`, loadData)}>
            <Button className="btn-item" shape="round" disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}>更新价格</Button>
        </Upload>
        <Upload showUploadList={false} {...importPropsConfig(`/ci-storage/base/material/import/update/${shopId}`, loadData)}>
            <Button className="btn-item" shape="round" disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}>更新</Button>
        </Upload> */}
    </>;

    return (
        <Spin {...uploading}>
            {/* <YhBox title="商品列表" action={action}> */}
            <YhBox title="商品列表" >
                <DataTable />
            </YhBox>
        </Spin>
    )
}

